<template lang="html">
  <div class="payments-component">
    <v-container>
      <v-progress-linear
            v-if="payments_loading"
            indeterminate
            color="red"
      ></v-progress-linear>
      <v-row justify="center">
      <p>{{no_payment_text}}</p>
      </v-row>

    <v-data-table
    v-if="student_payments != ''"
    :loading="loading"
    :headers="payments_headers"
    :items="student_payments"
    :mobile-breakpoint='NaN'
    show-expand
    item-key="invoice_number"
    >
      <template v-slot:item.data-table-expand="{ item, isExpanded, expand }">
        <v-btn icon @click="expand(true)" v-if="!isExpanded" text><v-icon>list</v-icon></v-btn>
        <v-btn icon @click="expand(false)" v-if="isExpanded"><v-icon>keyboard_arrow_up</v-icon></v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <b>Tételek:</b>
          <ul>
            <li v-for="c_item in item.payments" :key="c_item['payment_id']" @click="openPayment(item.id, item.invoice_number)">
              <b>Összeg:</b> {{c_item['amount']}} <b>Megnevezés:</b> {{c_item['item_name']}} <div v-if="c_item['used_payment'] && !c_item['teacher_id']" style="color:Purple;">(<b>Felhasználva:</b> {{c_item['used_payment']}})</div>
              <div v-for="r_item in c_item.requests" :key="r_item['tc_payment_id']" style="color:Purple;">(<b>Igényelés ideje:</b> {{r_item['request_date']}} <b>Igényelt összeg:</b> {{r_item['amount']}} <b>Oktató:</b> {{r_item['teacher_name']}} <b>Átvétel:</b> {{r_item['atvetel']}})</div>
            </li>
          </ul>
        </td>
      </template>
      <template v-slot:item.comment="props">
        <v-edit-dialog
          :return-value.sync="props.item.comment"
          large
          persistent
          save-text="Mentés"
          cancel-text="Mégsem"
          @save="updateComment(props.item.comment, props.item.billingo_id)"
        >
          <div>{{ props.item.comment }}</div>
          <template v-slot:input>
            <v-text-field
              v-model="props.item.comment"
              single-line
              autofocus
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.del_proform="props">
            <v-btn outlined fab small color="red" v-if="props.item.invoice_type_id == 1 && admin" @click="delProform(props.item.billingo_id)">
              <v-icon>delete</v-icon>
            </v-btn>
      </template>
    </v-data-table>

    <v-row>
      <v-col
        cols="6"
        md="3"
      >
      <v-btn
      color="primary"
      @click="newPayment"
      rounded
      >
      Új befizetés
      </v-btn>
      </v-col>

      <v-col
        cols="6"
        md="3"
      >

      <v-menu
        top
        left
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="pink"
            outlined
            rounded
            v-bind="attrs"
            v-on="on"
          >
            Egyösszegű
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="previewEgyosszegu()">
            <v-list-item-title>Igénylés</v-list-item-title>
          </v-list-item>
          <v-list-item @click="egyosszeguListNoPaid(), egyosszegu_select = 'nopaid'">
            <v-list-item-title>Műveletek</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      </v-col>

      <v-col
        cols="5"
        md="3"
      >
      <v-btn
      color="green"
      @click="getPayments"
      outlined
      rounded
      >
      Frissítés
      </v-btn>
      </v-col>

      <v-col
        cols="4"
        md="3"
        v-if="admin"
      >
      <v-btn
      color="blue"
      @click="getPaymentsToMove()"
      rounded
      outlined
      >
      Befizetés kezelés
      </v-btn>
      </v-col>

    </v-row>
  </v-container>

    <v-dialog
      v-model="teacher_dialog"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Egyösszegű igénylés
        </v-card-title>

        <v-card-text>
          <br>
          <v-data-table
            v-model="selected_items"
            :headers="headers"
            :items="invoice_details"
            :items-per-page="10"
            class="elevation-1"
            item-key="payment_id"
            show-select
            @input="onSelectionChange"
          >
          <template v-slot:item.data-table-select="{ isSelected, select, item }">
              <v-checkbox
                :input-value="isSelected"
                @change="select($event)"
                :disabled="(item.amount / item.full_price) % 1 !== 0"
              ></v-checkbox>
            </template>
            <template
              v-slot:item.oraszam="{ item }"
              >
              <input type="number" @input="updateRemainAmount(item)" v-model="item.oraszam" size="7" style="border: 1px solid grey; border-radius: 4px;">
            </template>
            <template
              v-slot:item.igeny="{ item }"
              >
              <input type="number" v-if="admin" :max="item.remain_amount" v-mask="'######'" v-model="item.remain_amount" size="10" style="border: 1px solid grey; border-radius: 4px;">
              <span v-if="!admin">{{ item.remain_amount }}</span>
            </template>
            <template
              v-if="admin"
              v-slot:item.full_price="{ item }"
              >
              <input type="number" v-model="item.full_price" size="7" style="border: 1px solid grey; border-radius: 4px;">
            </template>
          </v-data-table>
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Igénylés dátuma"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  scrollable
                  first-day-of-week=1
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Mégsem
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-select
              v-model="selected_teacher"
              :items="teachers"
              item-text="name"
              return-object
              label="Oktató"
              outlined
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-select
              v-model="selected_car"
              :items="teacher_cars"
              item-value="id"
              label="Autó"
              outlined
              >
              <template v-slot:item="data">
                <div>
                  {{ data.item.tipus }} - {{ data.item.rendszam }}
                </div>
              </template>

              <template v-slot:selection="data">
                <div>
                  {{ data.item.tipus }} - {{ data.item.rendszam }}
                </div>
              </template>  
            </v-select>
            </v-col>
            <v-col
              v-if="admin"
              cols="12"
              md="2"
            >
              <v-select
              v-model="loginuser"
              :items="login_users"
              item-text="name"
              item-value="loginuser"
              label="Iroda"
              outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            outlined
            @click="checkEgyosszegu()"
            :disabled="!selected_teacher || preloader || selected_items == '' || (teacher_cars != '' && !selected_car)"
            :loading="preloader"
          >
            Igénylés
          </v-btn>
          <v-btn
            color="red"
            outlined
            @click="teacher_dialog = false"
          >
            Mégsem
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="igeny_preview_dialog" persistent max-width="1000">
            <v-card>
              <v-container>
              <v-data-table
                  :headers="check_headers"
                  :items="check_items"
                  :items-per-page="10"
                  item-key="payment_id"
                  hide-default-header
                >
                <template v-slot:body="{ items }">
                    <thead>
                      <tr>
                        <th>Igényelt óraszám</th>
                        <th>Oktató óradíja</th>
                        <th>Oktatói igénylés</th>
                        <th>Felhasznált összeg</th>
                        <th></th>
                      </tr>
                    </thead>
                  <tbody>
                    <tr
                      v-for="item in items"
                      :key="item.payment_id"
                      :style="item.valid_price === 'false' ? { backgroundColor: '#ffdddd' } : {}"
                    >
                      <td>{{ item.oraszam }}</td>
                      <td>{{ item.teacher_oradij }}</td>
                      <td>{{ item.teacher_price }}</td>
                      <td>{{ item.remain_amount }}</td>
                      <td v-if="item.valid_price == 'false'" style="width: 350px;">{{ item.error_message }}</td>
                    </tr>
                  </tbody>
                </template>
                </v-data-table>
              </v-container>
              <v-card-actions>
                <v-btn color="red" outlined @click="igeny_preview_dialog = false">mégsem</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green" :loading="preloader" outlined :disabled="hasInvalidRow" @click="igenyEgyosszegu()">beküld</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>

    <v-dialog
      v-model="egyosszegu_mod_dialog"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Egyösszegű műveletek
        </v-card-title>

        <v-card-text>
          <br>
          <v-radio-group
            v-model="egyosszegu_select"
            row
          >
            <v-radio
              label="Átvett"
              value="paid"
            ></v-radio>
            <v-radio
              label="Nem átvett"
              value="nopaid"
            ></v-radio>
          </v-radio-group>
          <br>
          <v-data-table
            v-model="selected_egyosszeg"
            :headers="egyosszegu_headers"
            :items="egyosszeguek"
            :items-per-page="10"
            class="elevation-1"
            item-key="payment_id"
            show-select
            :loading="preloader"
            loading-text="Betöltés..."
            @click:row="egyosszeguMod($event)"
          ></v-data-table>
          <v-row v-if="egyosszegu_select == 'nopaid' && admin">
            <v-col
              cols="8"
              md="6"
            >
              <v-menu
                ref="menu2"
                v-model="menu2"
                :close-on-content-click="false"
                :return-value.sync="date2"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date2"
                    label="Átvétel dátuma"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date2"
                  no-title
                  scrollable
                  first-day-of-week=1
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu2 = false"
                  >
                    Mégsem
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu2.save(date2)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              class="mt-2"
              cols="4"
              md="6"
            >
            <v-btn
              color="primary"
              outlined
              :disabled="!selected_egyosszeg || selected_egyosszeg == '' || preloader"
              :loading="preloader"
              @click="atvetEgyosszegu()"
            >
              Átvétel
            </v-btn>
            </v-col>
          </v-row>
          <div v-if="modify">
            <v-row v-if="!atvet_date">
            <v-col
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="mod_oraszam"
                label="Óraszám"
                outlined
                type="number"
                @input="updateModAmount()"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="osszeg"
                label="Összeg"
                outlined
                disabled
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="2"
            >
              <v-text-field
                v-model="igenyles_date"
                label="Igénylés dátuma"
                outlined
                v-mask="'####-##-##'"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-select
              v-model="mod_teacher"
              :items="teachers"
              item-text="name"
              return-object
              label="Oktató"
              outlined
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
            <v-select
              v-model="selected_car_mod"
              :items="teacher_cars"
              item-value="id"
              label="Autó"
              outlined
              >
              <template v-slot:item="data">
                <div>
                  {{ data.item.tipus }} - {{ data.item.rendszam }}
                </div>
              </template>

              <template v-slot:selection="data">
                <div>
                  {{ data.item.tipus }} - {{ data.item.rendszam }}
                </div>
              </template>  
            </v-select>
            </v-col>
            </v-row>
            <v-row v-if="admin">
              <v-col
                cols="12"
                md="2"
              >
                <v-text-field
                  v-model="mod_full_price"
                  label="Óradíj"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="2"
              >
              <v-select
              v-model="loginuser"
              :items="login_users"
              item-text="name"
              item-value="loginuser"
              label="Iroda"
              outlined
              ></v-select>
            </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  :disabled="!atvet_date"
                  v-model="atvet_date"
                  label="Átvétel dátuma"
                  outlined
                  v-mask="'####-##-##'"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
              <v-btn
                :disabled="preloader || !igenyles_date || !osszeg || mod_teacher == '' || egyosszegu_select == 'paid'"
                :loading="preloader"
                color="primary"
                outlined
                @click="modEgyosszegu()"
              >
                Módosítás
              </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!selected_egyosszeg || selected_egyosszeg == '' || preloader"
            :loading="preloader"
            color="green"
            outlined
            @click="send_egyosszeg_dialog = true"
          >
            Küldés
          </v-btn>
          <v-btn
            color="red"
            outlined
            @click="egyosszegu_mod_dialog = false, modify = false"
          >
            Mégsem
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog v-model="send_egyosszeg_dialog" persistent max-width="500">
        <v-card>
          <br>
            <v-container>
              <v-form
                v-model="valid"
                lazy-validation
              >
              <v-row>
                <v-col class="d-flex" cols="12">
                  <v-combobox
                    v-model="email"
                    :items="fix_emails"
                    label="E-mail"
                    :rules="[rules.email]"
                    append-icon="email"
                    outlined
                  ></v-combobox>
                </v-col>
              </v-row>
              </v-form>
            </v-container>
          <v-card-actions>
            <v-btn color="red" outlined @click="send_egyosszeg_dialog = false, email = ''">Bezár</v-btn>
            <v-spacer></v-spacer>
          <v-btn color="blue" outlined @click="sendEgyosszegu()" :disabled="!valid || !email" :loading="preloader">Küld</v-btn>
            <v-btn color="green" outlined @click="printEgyosszegu()">Nyomtat</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    <v-dialog
      v-model="move_payment_dialog"
      width="950"
      hide-overlay
      transition="dialog-bottom-transition"
      fullscreen
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Befizetés áthelyezés
          <v-spacer></v-spacer>
            <v-btn
              icon
              @click="move_payment_dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-data-table
              :headers="payments_move_headers"
              :items="payments_move_items"
              :items-per-page="10"
            >
              <template v-slot:item.contract="{ item }">
                <v-select
                  v-model="item.contract_id"
                  :items="contracts"
                  item-text="contract_name"
                  item-value="contract_id"
                >
                  <template v-slot:selection="data">
                    <!-- HTML that describe how select should render selected items -->
                    {{ data.item.contract_name }} - {{ data.item.date }}
                  </template>
                  <template v-slot:item="data">
                    <!-- HTML that describe how select should render items when the select is open -->
                    {{ data.item.contract_name }} - {{ data.item.date }} ({{data.item.label}})
                  </template>
                </v-select>
                <v-text-field
                  v-model="item.contract_id"
                ></v-text-field>
              </template>
              <template v-slot:item.student_id="{ item }">
                <v-text-field
                  v-model="item.student_id"
                ></v-text-field>
              </template>
              <template
              v-slot:item.etitan_payment="{ item }"
              >
              <input v-model="item.etitan_payment">
            </template>
            <template
              v-slot:item.used="{ item }"
              >
              <input v-model="item.used">
            </template>
            <template
              v-slot:item.exam_data_id="{ item }"
              >
              <input v-model="item.exam_data_id">
            </template>
            <template
              v-slot:item.product_uid="{ item }"
              >
              <input v-model="item.product_uid">
            </template>
            <template
              v-slot:item.kav_payments="{ item }"
              >
                <v-btn
                  v-if="item.used"
                  color="blue"
                  outlined
                  @click="getDijlekotesek(item)"
                >
                  Díjlekötések
                </v-btn>
            </template>
            </v-data-table>
            Szerződés azonosító: {{contract_id}}
            <br>
            Ügyfél azonosító: {{customer_id}}
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            outlined
            @click="MovePayments()"
          >
            rögzít
          </v-btn>
        </v-card-actions>
      </v-card>

        <v-dialog v-model="dijlekotes_dialog" persistent max-width="900">
            <v-card>
              <v-container>
              <v-data-table
                v-model="selectedVdToFree"
                :headers="dijlekotes_headers"
                :items="dijlekotesek"
                :items-per-page="10"
                class="elevation-1"
                single-select
                item-key="idopont"
                show-select
              >
                <template
                v-slot:item.details="{ item }"
                >
                  <v-btn
                    v-if="item.Ervenytelenitve"
                    color="blue"
                    outlined
                  >
                    <v-icon>list</v-icon>
                  </v-btn>
              </template>
              </v-data-table>
              </v-container>
              <v-card-actions>
                <v-btn color="red" outlined @click="dijlekotes_dialog = false">Bezár</v-btn>
                <v-spacer></v-spacer>
                <v-btn :disabled="selectedVdToFree == ''" color="green" outlined @click="freeVd()">Felszabadít</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

    </v-dialog>

    <v-snackbar
      v-model="snackbar"
    >
      {{ response_text }}
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Bezár
        </v-btn>
    </v-snackbar>

  </div>
</template>

<script>
import store from '../store'
import {mapFields} from 'vuex-map-fields'

  export default {
    data () {
      return {
        loading: false,
        student_payments: '',
        teacher_dialog: false,
        egyosszegu_mod_dialog: false,
        date: new Date().toISOString().substr(0, 10),
        menu: false,
        date2: new Date().toISOString().substr(0, 10),
        menu2: false,
        teachers: [],
        selected_teacher: '',
        selected_invoice: '',
        invoice_details: [],
        headers: [
          { text: 'Számla összeg', value: 'amount', width: 150},
          { text: 'Megigényelt', value: 'requested_amount', width: 100},
          { text: 'Óraszám', value: 'oraszam', width: 20},
          { text: 'Óradíj', value: 'full_price', width: 50},
          { text: 'Igénylés', value: 'igeny', width: 100},
          { text: 'Megnevezés', value: 'item_name', width: 150},
          { text: 'Dátum', value: 'paid_date', width: 150},
          { text: 'Számlaszám', value: 'invoice_number', width: 200},
          { text: 'Név', value: 'billing_name', width: 250},
        ],
        egyosszegu_headers: [
          { text: 'Összeg', value: 'amount', width: 100},
          { text: 'Megnevezés', value: 'item_name', width: 150},
          { text: 'Igénylés dátuma', value: 'used', width: 150},
          { text: 'Számlaszám', value: 'invoice_number', width: 150},
          { text: 'Oktató', value: 'teacher', width: 150},
          { text: 'Átvétel', value: 'atvetel', width: 150},
        ],
        payments_headers: [
          { text: 'Összeg', value: 'amount', width: 100},
          { text: 'Státusz', value: 'status', width: 150},
          { text: 'Fizetési mód', value: 'payment_type', width: 150},
          { text: 'Bizonylat típus', value: 'invoice_type', width: 150},
          { text: 'Befizetés ideje', value: 'invoice_date', width: 150},
          { text: 'Kiegyenlítve', value: 'paid_date', width: 150},
          { text: 'Számlaszám', value: 'invoice_number', width: 150},
          { text: 'Megjegyzés', value: 'comment', width: 150},
          { text: '', value: 'del_proform', width: 50},
        ],
        payments_move_headers: [
          { text: 'Összeg', value: 'amount', width: 100},
          { text: 'Fizetési mód', value: 'payment_type', width: 150},
          { text: 'Bizonylat típus', value: 'invoice_type', width: 150},
          { text: 'Befizetés ideje', value: 'invoice_date', width: 150},
          { text: 'Számlaszám', value: 'invoice_number', width: 150},
          { text: 'payment_id', value: 'payment_id', width: 150},
          { text: '', value: 'contract', width: 200},
          { text: 'Ügyfél azonosító', value: 'student_id', width: 150},
          { text: 'E-learning', value: 'etitan_payment', width: 200},
          { text: 'Vizsgadíj', value: 'used', width: 200},
          { text: 'Vizsga ID', value: 'exam_data_id', width: 150},
          { text: 'Termék ID', value: 'product_uid', width: 150},
          { text: 'Díjlekötések', value: 'kav_payments', width: 50},
        ],
        dijlekotes_headers: [
          { text: 'Dátum', value: 'idopont', width: 100},
          { text: 'Típus', value: 'vizsga', width: 200},
          { text: 'Tanuló', value: 'nev', width: 150},
        ],
        selected_items: [],
        selected_egyosszeg: [],
        egyosszeguek: [],
        snackbar: false,
        response_text: '',
        egyosszegu_select: 'nopaid',
        modify: false,
        osszeg: '',
        igenyles_date: '',
        mod_teacher: '',
        mod_teacher_name: '',
        tc_payment_id: '',
        atvet_date: '',
        mod_payment_id: '',
        send_egyosszeg_dialog: false,
        email: '',
        rules: {
          required: value => !!value || 'Kötelező mező!',
          email: value => {
            if(value != null) {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              return pattern.test(value) || 'Hibás e-mail cím!'
            }
          },
        },
        valid: true,
        fix_emails: [
          'dattila@csigajogsi.hu',
          'hartmansandor@gmail.com',
        ],
        move_payment_dialog: false,
        payments_move_items: [],
        contracts: [],
        no_payment_text: '',
        payments_loading: false,
        dijlekotesek: [],
        dijlekotes_dialog: false,
        selectedVdToFree: [],
        igeny_preview_dialog: false,
        check_items: [],
        check_headers: [
          { text: 'Igényelt óraszám', value: 'oraszam', width: 150},
          { text: 'Oktató óradíja', value: 'teacher_oradij', width: 150},
          { text: 'Oktatói igénylés', value: 'teacher_price', width: 150},
          { text: 'Felhasznált összeg', value: 'remain_amount', width: 150},
          { text: 'Hibaüzenet', value: 'error_message', width: 300},
        ],
        mod_full_price: '',
        mod_reduced_price: '',
        mod_oraszam: '',
        teacher_cars: [],
        selected_car: '',
        selected_car_mod: '',
        paid_date_mod: '',
        login_users: []
      }
    },
    methods: {
      getPayments: async function() {
        //this.no_payment_text = 'A számlák betöltés alatt...'
        this.student_payments = []
        this.payments_loading = true
        await this.gettoken()
        this.$http.post('/diakok/diakok_befizetes_20230117', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.no_payment_text = ''
          this.student_payments = response.data
          if (this.student_payments == '') {
            this.no_payment_text = 'A tanulónak még nincsenek befizetései'
          }
          this.payments_loading = false
        }, (error) => {
          console.log(error.data);
        })
      },
      getUsers: async function() {
        await this.gettoken()
        this.$http.post('/diakok/login_users', {
          token: this.token
        }).then((response) => {
          this.login_users = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getPaymentsToMove: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/diakok_befizetes_to_move', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
        }).then((response) => {
          this.move_payment_dialog = true
          this.loading = false
          this.payments_move_items = response.data['payments'];
          this.contracts = response.data['contracts'];
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      MovePayments: async function() {
        await this.gettoken()
        this.$http.post('/diakok/diakok_befizetes_move_240118', {
          token: this.token,
          payments_move_items: this.payments_move_items
        }).then((response) => {
          this.response_text = response.data;
          this.move_payment_dialog = false
          this.getPayments()
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      getTeachers: async function() {
        this.teachers = null
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/teacher_list', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.loading = false
          this.teachers = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      printEgyosszegu: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyosszegu_print', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payments: this.selected_egyosszeg
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }, (error) => {
          console.log(error.data);
        })
      },
      sendEgyosszegu: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyosszegu_send', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payments: this.selected_egyosszeg,
          email: this.email
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data['message']
          this.teacher_dialog = false;
          this.send_egyosszeg_dialog = false;
          this.snackbar = true;
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      igenyEgyosszegu: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyosszegu_igeny_250523', {
          token: this.token,
          teacher_id: this.selected_teacher,
          date: this.date,
          items: this.check_items,
          contract_id: this.contract_id,
          loginuser: this.loginuser
        }).then((response) => {
          this.preloader = false
          if (response.data['result'] == 'false') {
            this.snackbar = true;
            this.response_text = response.data['message']
          } else {
          this.selected_egyosszeg = response.data['items']
          this.send_egyosszeg_dialog = true
          this.igeny_preview_dialog = false
          this.getPayments()
          this.teacher_dialog = false
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      checkEgyosszegu: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyosszegu_check_250611', {
          token: this.token,
          teacher_id: this.selected_teacher,
          date: this.date,
          items: this.selected_items,
          contract_id: this.contract_id,
          loginuser: this.loginuser,
          selected_car: this.selected_car
        }).then((response) => {
          this.preloader = false
          this.check_items = response.data
          this.igeny_preview_dialog = true
        }, (error) => {
          console.log(error.data);
        })
      },
      getCar: async function(value) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/oktatok/teacher_cars', {
          token: this.token,
          teacher_id: value
        }).then((response) => {
          this.preloader = false
          this.teacher_cars = response.data
        }, (error) => {
          this.preloader = false
          console.log(error.data);
        })
      },
      checkEgyediOradij: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyedi_check_250611', {
          token: this.token,
          teacher_id: this.selected_teacher['teacher_id'],
          selected_car: this.selected_car,
          contract_id: this.contract_id,
          payments: this.invoice_details
        }).then((response) => {
          if (response.data['result'] == true) {
            const newPrice = response.data['oradij'];
            this.invoice_details.forEach((item, index) => {
            const newOraszam = item.remain_amount / newPrice;
            this.$set(this.invoice_details[index], 'reduced_price', newPrice);
            this.$set(this.invoice_details[index], 'full_price', newPrice);
            this.$set(this.invoice_details[index], 'oraszam', newOraszam);
          });
          }
          if (response.data['result'] == 'car') {
            this.invoice_details = response.data['payments'];
            this.selected_items = []
          }
          this.preloader = false
          console.log(this.invoice_details);
        }, (error) => {
          this.preloader = false
          console.log(error.data);
        })
      },
      checkModEgyediOradij: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyedi_check_250611', {
          token: this.token,
          teacher_id: this.mod_teacher['teacher_id'],
          selected_car: this.selected_car_mod,
          contract_id: this.contract_id,
          mod: true,
          paid_date_mod: this.paid_date_mod
        }).then((response) => {
          if (response.data['result'] == true) {
          const newPrice = response.data['oradij'];
          this.mod_full_price = newPrice,
          this.mod_reduced_price = newPrice
          this.updateModAmount()
          }
          if (response.data['result'] == 'mod_both') {
            this.mod_full_price = response.data['full_price']
            this.mod_reduced_price = response.data['reduced_price']
          this.updateModAmount()
          }
          this.preloader = false
        }, (error) => {
          this.preloader = false
          console.log(error.data);
        })
      },
      atvetEgyosszegu: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyosszegu_atvet_221228', {
          token: this.token,
          date: this.date2,
          items: this.selected_egyosszeg
        }).then((response) => {
          this.preloader = false
          this.getPayments()
          this.egyosszegu_mod_dialog = false
          this.snackbar = true
          this.response_text = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      modEgyosszegu: async function() {
        if (confirm('Biztosan módosítani szeretné a sort?')) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyosszegu_mod_250704', {
          token: this.token,
          osszeg: this.osszeg,
          igenyles_date: this.igenyles_date,
          mod_teacher: this.mod_teacher,
          atvet_date: this.atvet_date,
          mod_payment_id: this.mod_payment_id,
          tc_payment_id: this.tc_payment_id,
          contract_id: this.contract_id,
          full_price: this.mod_full_price,
          reduced_price: this.mod_reduced_price,
          oraszam: this.mod_oraszam,
          selected_car: this.selected_car_mod,
          loginuser: this.loginuser
        }).then((response) => {
          this.modify = false
          this.preloader = false
          this.getPayments()
          if (this.atvet_date != null) {
            this.egyosszeguList()
          } else {
            this.egyosszeguListNoPaid()
          }
          this.snackbar = true
          this.response_text = response.data
        }, (error) => {
          console.log(error.data);
        })
       }
      },
      previewEgyosszegu: async function() {
        this.selected_items = []
        this.selected_teacher = ''
        this.teacher_cars = []
        this.selected_car = ''
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyosszegu_preview_250520', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.preloader = false
          this.teacher_dialog = true
          this.invoice_details = response.data;
          this.selected_invoice = response.data[0]['invoice_id'];
          this.invoice_details = this.invoice_details.map(item => ({
            ...item,
            original_remain_amount: item.remain_amount,
            original_oraszam: item.oraszam,
          }));
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      egyosszeguList: async function() {
        this.egyosszeguek = []
        this.selected_egyosszeg = []
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyosszegu_list_221228', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.preloader = false
          this.egyosszegu_mod_dialog = true
          this.egyosszeguek = response.data;
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      egyosszeguListNoPaid: async function() {
        this.selected_egyosszeg = []
        this.egyosszeguek = []
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/egyosszegu_nopaid_250526', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.preloader = false
          this.egyosszegu_mod_dialog = true
          this.egyosszeguek = response.data;
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      egyosszeguMod(value) {
        this.modify = true
        this.osszeg = value.amount
        this.igenyles_date = value.used
        this.mod_teacher = parseInt(value.teacher_id);
        this.atvet_date = value.atvetel
        this.mod_payment_id = value.payment_id
        this.tc_payment_id = value.tc_payment_id,
        this.mod_full_price = value.full_price,
        this.mod_reduced_price = value.reduced_price,
        this.mod_oraszam = value.oraszam,
        this.paid_date_mod = value.paid_date
        console.log(value);
      },
      updateRemainAmount(item) {
        const oraszam = Number(item.oraszam) || 0;
        const oradij = Number(item.full_price) || 0;
        item.remain_amount = oraszam * oradij;
        if (item.remain_amount > item.original_remain_amount) {
          item.remain_amount = item.original_remain_amount;
          //item.oraszam = item.original_oraszam;
          item.oraszam = item.original_remain_amount/oradij;
        }
      },
      updateModAmount() {
        const oraszam = Number(this.mod_oraszam) || 0;
        const oradij = Number(this.mod_full_price) || 0;
        this.osszeg = oraszam * oradij;
      },
      openPayment(id, invoice_number) {
          window.open("https://szamlazo.csigaver.hu/billing?id="+id+"&invoice_id="+invoice_number);
      },
      newPayment() {
        window.open("https://szamlazo.csigaver.hu/?customerId="+this.customer_id+"&contractId="+this.contract_id);
      },
      updateComment: async function(comment, id) {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/update_payments_comment', {
          token: this.token,
          contract_id: this.contract_id,
          comment: comment,
          iv_id: id
        }).then((response) => {
          this.snackbar = true
          this.loading = false
          this.response_text = response.data;
          this.getPayments()
        }, (error) => {
          console.log(error.data);
        })
      },
      delProform: async function(proform_id) {
       if (confirm("Biztosan törli a díjbekérőt?") == true) {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/del_proform', {
          token: this.token,
          proform_id: proform_id
        }).then((response) => {
          this.snackbar = true
          this.loading = false
          this.response_text = response.data;
          this.getPayments()
        }, (error) => {
          console.log(error.data);
        })
       }
      },
      getDijlekotesek: async function(items) {
        this.selectedVdToFree = [];
        this.kepzesi_send = true
        await this.gettoken()
        this.$http.post('/kokeny/dijlekotesek', {
          token: this.token,
          school_id: items.driving_school_id,
          date: items.used,
          usedVdId: items.payment_id
        }).then((response) => {
          this.dijlekotesek = response.data;
          this.dijlekotes_dialog = true;
          console.log(this.dijlekotesek);
        }, (error) => {
          console.log(error.data);
        })
      },
      freeVd: async function() {
        await this.gettoken()
        this.$http.post('/kokeny/freeVd', {
          token: this.token,
          payment_id: this.selectedVdToFree[0]['payment_id']
        }).then((response) => {
          this.selectedVdToFree = null;
          this.response_text = response.data;
          this.dijlekotes_dialog = false;
          this.move_payment_dialog = false;
          this.getPayments()
          this.snackbar = true;
        }, (error) => {
          console.log(error.data);
        })
      },
      onSelectionChange(newSelection) {
        // csak azokat engedjük kijelölni, amik validak
        this.selected_items = newSelection.filter(item => {
          return item.full_price !== 0 && (item.amount / item.full_price) % 1 === 0;
        });
      },
    },
    mounted() {
      this.getTeachers()
      this.getUsers()
    },
    watch: {
      contract_id() {
        if (this.diakok_tab == 5) {
          this.getPayments()
          this.getTeachers()
        }
      },
      diakok_tab: function (value) {
        if (value == 5) {
          this.getPayments()
          this.getTeachers()
        }
      },
      selected_teacher: function (value) {
        this.checkEgyediOradij()
        this.getCar(value.teacher_id)
        this.selected_car = ''
      },
      selected_car: function () {
        this.checkEgyediOradij()
      },
      mod_teacher: function (value) {
        this.checkModEgyediOradij()
        this.getCar(value.teacher_id)
      },
      selected_car_mod: function () {
        this.checkModEgyediOradij()
      },
      egyosszegu_select: function (value) {
        this.modify = false
        if (value == 'paid') {
          this.egyosszeguList()
        } else if (value == 'nopaid') {
          this.egyosszeguListNoPaid()
        }
      }
    },
    computed: {
      hasInvalidRow() {
        return this.check_items.some(item => item.valid_price === 'false');
      },
    ...mapFields([
      'diakok_details.contract_id',
      'diakok_details.customer_id',
      'showing.preloader',
      'diakok_details.diakok_tab',
      'auth.prod',
      'auth.admin',
      'auth.loginuser',
  ]),
  },
  }
</script>

<style lang="css">

</style>
